export function templateLayoutLabel(payload: Record<string, unknown>): string {
  const config = payload.timeframe_config as { data_roles?: Record<string, string> } | undefined;
  const roles = config?.data_roles;
  if (!roles?.signal) return "周期待核对";
  return [roles.signal, roles.structure, roles.context].filter(Boolean).join(" → ");
}
